import { Services } from "appworks/services/services";

export function TGRSetupI18n() {

    // Infinity " "
    Services.translations.set("infinity", "∞");
    Services.translations.setAlias("aut.inf", "infinity");
    Services.translations.setAlias("clk.ply", "click_anywhere_to_play");
    Services.translations.setAlias("tap.ply", "tap_anywhere_to_play");
    Services.translations.setAlias("you.win", "bonus_you_win");
    Services.translations.setAlias("commonui.freerounds", "commonui_freerounds");
    Services.translations.setAlias("cui.spl", "commonui_spinsleft");
    Services.translations.setAlias("aut.lol", "loss_limit_reached");
    Services.translations.setAlias("aut.swl", "single_win_limit_reached");
    Services.translations.setAlias("rec.spi", "recovering_game");
    Services.translations.setAlias("fot.new", "footer_welcome");
    Services.translations.setAlias("fot.gam", "player_wins_x");
    Services.translations.setAlias("fot.lin", "line_x_wins_y");
    Services.translations.setAlias("bet.chg", "bet_changed");
    Services.translations.setAlias("upd.gam", "updating_game");
    Services.translations.setAlias("ui.bet", "bet");
    Services.translations.setAlias("ui.max", "max_bet_caps");
    Services.translations.setAlias("ui.aut", "auto");
    Services.translations.setAlias("ui.gam", "gamble");
    Services.translations.setAlias("ui.col", "collect");
    Services.translations.setAlias("pre.msg", "preloader_ad");
    Services.translations.setAlias("prl.loa", "loading");
    Services.translations.setAlias("bon.ftr", "bonus_feature");
    Services.translations.setAlias("bon.win", "win_caps");
    Services.translations.setAlias("spn.spd", "turbo_caps");
    Services.translations.setAlias("dnt.shw", "dont_show_again");
    Services.translations.setAlias("con.tin", "continue");
    Services.translations.setAlias("autoplay_title", "auto_play");
    Services.translations.setAlias("number_of_autoplays", "commonui_select_number");
    Services.translations.setAlias("loss_limit", "commonui_stopautospin");
    Services.translations.setAlias("single_win_limit", "commonui_stop_if_exceeds");
    Services.translations.setAlias("freespins_caps", "free_spins_caps");
    Services.translations.setAlias("fsw.con", "congratulations");
    Services.translations.setAlias("fsw.xfs", "x_freespins_awarded");
    Services.translations.setAlias("fsw.fsp", "free_spins_caps");
    Services.translations.setAlias("jac.min", "mini_caps");
    Services.translations.setAlias("jac.mnr", "minor_caps");
    Services.translations.setAlias("jac.maj", "major_caps");
    Services.translations.setAlias("jac.gnd", "grand_caps");
    Services.translations.setAlias("initial", "game_history_initial_balance_label");
    Services.translations.setAlias("final", "game_history_final_balance_label");
    Services.translations.setAlias("time", "game_history_time_label");
    Services.translations.setAlias("session_id", "game_history_session_id");
}
